import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Copy({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M7.33337 4C6.2288 4 5.33337 4.89543 5.33337 6V14C5.33337 15.1046 6.2288 16 7.33337 16H12.6667C13.7713 16 14.6667 15.1046 14.6667 14V6C14.6667 4.89543 13.7713 4 12.6667 4H7.33337ZM6.66671 6C6.66671 5.63181 6.96518 5.33333 7.33337 5.33333H12.6667C13.0349 5.33333 13.3334 5.63181 13.3334 6V14C13.3334 14.3682 13.0349 14.6667 12.6667 14.6667H7.33337C6.96518 14.6667 6.66671 14.3682 6.66671 14V6Z"
        fill={iconColor}
      />
      <Path
        d="M9.33337 17.3333V18C9.33337 19.1046 10.2288 20 11.3334 20H16.6667C17.7713 20 18.6667 19.1046 18.6667 18V10C18.6667 8.89543 17.7713 8 16.6667 8H16V9.33333H16.6667C17.0349 9.33333 17.3334 9.63181 17.3334 10V18C17.3334 18.3682 17.0349 18.6667 16.6667 18.6667H11.3334C10.9652 18.6667 10.6667 18.3682 10.6667 18V17.3333H9.33337Z"
        fill={iconColor}
      />
    </Svg>
  );
}
